import React from 'react';
import {get, isEmpty} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {formatTimeByOffset, getDateUtilDefaultInstance} from '/util/date.util';

interface LastOrderedDateItem {
  lastOrderedOn?: string | null;
}

interface LastOrderedDateProps {
  tt: (key: string, options?: object) => string;
  item: LastOrderedDateItem;
}

export const LastOrderedDate: React.FC<LastOrderedDateProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = {},
}) => {
  const lastOrderedOn = get(item, 'lastOrderedOn', '');
  const convertedToLastOrderedOnTime = formatTimeByOffset(lastOrderedOn);
  return (
    <Text
      testID={Reports.reportClientLastOrderedDate}
      allowFontScaling
      maxFontSizeMultiplier={2}>
      {isEmpty(lastOrderedOn)
        ? tt('noOrders', 'No Orders Yet')
        : tt(
            'lastOrderedOn',
            generateComponentCallback({
              component: (
                <>
                  Last Ordered{' '}
                  {getDateUtilDefaultInstance().formatDate(
                    convertedToLastOrderedOnTime,
                    'MMMM d, yyyy',
                  )}
                </>
              ),
            }),
          )}
    </Text>
  );
};

export default withTranslation('report.record.lastOrderedDate')(
  LastOrderedDate,
);
